/****************************************************
 * Module Name:  countryProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CountryProxy {
  static GetAllCountry = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/country",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleCountry = (countryId, callback) => {
    let params = {
      id: countryId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/country",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckCountryAvailable = (country, callback) => {
    let params = {
      country: country,
    };

    restAPICall(
      Constants.MANAGER_URL + "/country/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddCountry = (country, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/country",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(country),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateCountry = (country, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/country",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(country),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteCountry = (country, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/country",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(country),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
